'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PaginationRootContext } from './context/pagination-root.context';
import { paginationItemStyles } from './styles/pagination-item.styles';
import type { PaginationItemPropsInterface } from './types/pagination-item.types';

/**
 * The paginations's `li` element
 * @since 10.0.0
 */
export const PaginationItem = forwardRef<HTMLLIElement, PaginationItemPropsInterface>(
  (props, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;

    const { showNumberButtons } = useContext(PaginationRootContext);

    const styles = css(paginationItemStyles.raw({ ...showNumberButtons }), cssProp);

    return (
      <li
        className={cx('c11n', 'c11n_pagination__item', styles, className)}
        data-c11n-component="Pagination.Item"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        {...rest}
      />
    );
  },
);

PaginationItem.displayName = 'Pagination.Item';
